import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, DeferLoadingStrategy, FeaturesConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { AppliedCouponsComponent } from './applied-coupons/applied-coupons.component';
import { ShimanoCartCouponComponent } from './cart-coupon.component';

@NgModule({
  declarations: [ShimanoCartCouponComponent, AppliedCouponsComponent],
  exports: [ShimanoCartCouponComponent, AppliedCouponsComponent],
  imports: [
    FeaturesConfigModule,
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    IconModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartApplyCouponComponent: {
          component: ShimanoCartCouponComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class CartCouponModule {}
